import { ChangeDetectionStrategy, Component, OnInit, signal } from "@angular/core";
import { SortColumn } from "../models/sortColumn.model";
import { BehaviorSubject, Observable, map } from "rxjs";
import { InLineControlRulesTableColumns } from "../models/tableColumns/inLineControlRulesTableColumns.model";
import { InLineControlRulesViewModel } from "../models/viewModels/InLineControlRulesViewModel";
import { PoliciesInLineControlRulesHttpService } from "../services/httpServices/policesInLineControlRulesHttpService/polices-in-line-control-rules-http.service";
import { ITablePageInfo } from "src/app/models/componentInputs/tablePageInfo.interface";
import { LabelsProviderPipe } from "../pipes/labels-provider/labels-provider.pipe";

@Component({
    selector: "app-in-line-control-rules",
    templateUrl: "./in-line-control-rules.component.html",
    styleUrl: "./in-line-control-rules.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InLineControlRulesComponent implements OnInit {
    public isLoading = signal<boolean>(false);
    public sortedColumn = signal<SortColumn | undefined>(undefined);
    public tableColumns = InLineControlRulesTableColumns;
    public inLineControlRulesCurrentPage$ = new BehaviorSubject<InLineControlRulesViewModel[]>([]);
    public tableRows$: Observable<BehaviorSubject<InLineControlRulesViewModel>[]>;
    public inLineControlRulesData: InLineControlRulesViewModel[] = [];
    public totalItems: number = 0;
    public showNoData = false;
    public pageInfo$: BehaviorSubject<ITablePageInfo>;
    public defaultPageSize: number;
    private _notAvailableString: string;

    constructor(
        private _inLineControlRulesHttpService: PoliciesInLineControlRulesHttpService,
        private _labelsProviderPipe: LabelsProviderPipe,
    ) {
        this.defaultPageSize = this._inLineControlRulesHttpService.defaultPageSize;
        this._notAvailableString = this._labelsProviderPipe.transform("common.notAvailable");
        this._initializePageInfo();
        this.tableRows$ = this.inLineControlRulesCurrentPage$.pipe(map((items) => items.map((item) => new BehaviorSubject(item))));
    }
    //Update Sorting (called from Child)
    public onSortedColumnChange(newSortColumn: SortColumn): void {
        this.sortedColumn.set(newSortColumn);
    }

    public ngOnInit(): void {
        this.fetchInLineControlRulesData();
    }

    public fetchInLineControlRulesData(): void {
        this.isLoading.set(true);
        this._inLineControlRulesHttpService.getInLineControlRules().subscribe(
            (data: InLineControlRulesViewModel[]) => {
                this.inLineControlRulesData = data;
                this.totalItems = this.inLineControlRulesData.length;
                const viewModels = this.inLineControlRulesData.map((item) => this._transformToViewModel(item));
                this.inLineControlRulesCurrentPage$.next(viewModels);
                this.showNoData = viewModels.length === 0;
                this.isLoading.set(false);
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (error: any) => {
                console.error("Error fetching in-line control data:", error);
                this.showNoData = true;
                this.isLoading.set(false);
                this.inLineControlRulesCurrentPage$.next([]);
            },
        );
    }

    private _transformToViewModel(row: InLineControlRulesViewModel): InLineControlRulesViewModel {
        console.log("row:", row);
        return {
            rowId: row.id,
            id: row.id,
            ruleName: row.ruleName ? row.ruleName : "",
            ruleId: row.ruleId,
            detections: row.detections,
            severity: row.severity,
            detection: row.detection,
            prevention: row.prevention,
            status: row.status,
            clickable: false,
            toggleState: typeof row.detection === "boolean" ? row.detection : row.detection === "true",
        };
    }

    private _initializePageInfo() {
        this.pageInfo$ = new BehaviorSubject<ITablePageInfo>({
            number: 1,
            currSize: 1,
            maxSize: this._inLineControlRulesHttpService.defaultPageSize,
            totalItems: 1,
            totalPages: 1,
        });
    }
}
